import React from 'react';
import { Form } from '@bd-uikit-web/React/Form';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import autobind from '@bd-uikit-web/js-helpers/autobind';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
} from 'react-stripe-elements';
import FormHelper from '@bd-uikit-web/React/FormHelper';

class StripeCheckoutForm extends React.Component {
  constructor() {
    super();
    const user = bdAuth.getUser();

    this.state = {
      user,
    };
  }

  showNotiBanner(type, message) {
    rootDispatcher.dispatch('NB:OPEN', {
      type,
      msg: message,
    });
  }

  @autobind
  handleSubmit() {
    const { email } = this.props;
    // add subscription
    this.props.stripe.createToken({ email }).then(({ token }) => {
      this.props.onToken(token);
    });
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="card">
          <div className="row">
            <h4 className=" h--normalize-weight h--spacing-sm h--lower">Checkout</h4>
          </div>
          <div className="row row--push-btm-xs">
            <label class="form__desc-label">
              <strong>Creditcard Number</strong>
            </label>
            <CardNumberElement />
          </div>
          <div className="row row--push-btm-xs">
            <label class="form__desc-label">
              <strong>Valid Thru</strong>
            </label>
            <CardExpiryElement />
          </div>
          <div className="row row--push-btm-xs">
            <label class="form__desc-label">
              <strong>CVC</strong>
            </label>
            <CardCVCElement />
          </div>
          <div className="row">
            <button className="btn btn--block" type="submit">
              {' '}
              {`Pay $${this.props.amount}`}
            </button>
          </div>
        </div>
      </Form>
    );
  }
}

export default injectStripe(StripeCheckoutForm);
